module.exports = __webpack_public_path__ + "/build/web/images/register-training.86ba0d9a27260a013020e4c856e5636f.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/register-training.jpg
// module id = 191
// module chunks = 13